/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { getCollegeData, matchCollegeTookClassOption } from 'app/highSchoolSlice/highSchoolSlice';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import CardConfig from 'components/CardConfig';
import CheckboxInput from 'components/input/CheckboxInput';
import GroupRadioButton from 'components/input/GroupRadioButton';
import SelectInput from 'components/input/SelectInput';
import TextInput from 'components/input/textInput';
import { FormikProps } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { FormCourse, SubjectDetail } from 'modal/course';
import {
  // BoolToString,
  checkEnableParseJSON,
  // formatBoolean,
  setArrayLength,
  checkCouserNameIncludes,
  tryParseJSON,
} from 'components/helper/helper';
import {
  gradingScale2Options,
  classTypeOption,
  subjectAreaOptions,
  getSubjectsByType,
} from './courseConstant';
import SuggestCourse from './SuggestCourse';
import { buildCourseSuggestParams } from './courseSuggestParams';
import courseServices from 'services/courseServices';

import {
  getACTSubjectTest,
  getIBSubjectTest,
  updateACTSubjectTest,
  // updateIBSubjectTest,
  getGeneral,
  updateGeneral,
} from 'app/testingSlice/testingSlice';
import Grid from '@mui/joy/Grid';
import { fixCourseValues } from 'screen/common/helper/fixValuesOnLoad';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';

type Props = {
  courseIndex: number; // 1,2,3...
  form: FormikProps<FormCourse>;
  item: SubjectDetail;
  index: number; // 0.1.2.
  total: number;
  is12?: boolean;
  gradingOptions: any[];
  expandAll?: boolean;
  disabled?: boolean;
  /** Userpilot prefix, e.g. `g9`. */
  dataUpPrefix?: string;
};

const RETAKE_GRADE_LABELS: Record<string, string> = {
  grade_9_course_array: '9th Grade',
  grade_10_course_array: '10th Grade',
  grade_11_course_array: '11th Grade',
  grade_12_course_array: '12th Grade',
};

const retakeGradeLabelFromPath = (pathname: string) => {
  if (pathname.includes('/12th-grade')) return '12th Grade';
  if (pathname.includes('/11th-grade')) return '11th Grade';
  if (pathname.includes('/10th-grade')) return '10th Grade';
  if (pathname.includes('/9th-grade')) return '9th Grade';
  return '';
};

/** Term grades joined with a space (`A+ B-`), otherwise the final grade. */
const retakeGradeText = (subject: any) => {
  const terms = Array.isArray(subject?.grade)
    ? subject.grade.map((grade: any) => `${grade ?? ''}`.trim()).filter(Boolean)
    : [];
  if (terms.length) return terms.join(' ');
  return `${subject?.finalGrade ?? ''}`.trim();
};

const formatRetakeOption = (gradeLabel: string, subject: any) => {
  const name = `${subject?.courseName ?? ''}`.trim();
  if (!name) return '';
  const gradeText = retakeGradeText(subject);
  const prefix = gradeLabel ? `${gradeLabel} - ` : '';
  return gradeText ? `${prefix}${name} : ${gradeText}` : `${prefix}${name}`;
};

/** Course label with only the grades of the semesters still checked. */
const retakeSelectionLabel = (
  option: { name: string; terms?: { index: number; label: string }[] } | undefined,
  semesterIndexes: number[]
) => {
  if (!option?.name) return '';
  const prefix = option.name.includes(' : ')
    ? option.name.slice(0, option.name.lastIndexOf(' : '))
    : option.name;
  const grades = (option.terms ?? [])
    .filter((term) => semesterIndexes.includes(term.index))
    .map((term) => {
      const parts = term.label.split(' : ');
      return parts.length > 1 ? parts[parts.length - 1].trim() : '';
    })
    .filter(Boolean);
  return grades.length ? `${prefix} : ${grades.join(' ')}` : prefix;
};

const RETAKE_TERM_FLAGS = [
  'isFirstSemester',
  'isSecondSemester',
  'isThirdSemester',
  'isFourthSemester',
] as const;

const retakeScheduleOf = (schedule: string, subject: any) => {
  if (schedule === 'Yearly' || schedule === 'Full Year') return 'Yearly';
  if (schedule === 'Quarter' || schedule === 'Quarters') return 'Quarters';
  if (schedule === 'Semester' || schedule === 'Trimester') return schedule;
  if (subject?.isFourthSemester) return 'Quarters';
  if (subject?.isThirdSemester) return 'Trimester';
  if (subject?.isFirstSemester || subject?.isSecondSemester) return 'Semester';
  return '';
};

/** Terms the original course was actually taken in, with that term's grade. */
const retakeTermsFor = (schedule: string, subject: any) => {
  const resolved = retakeScheduleOf(schedule, subject);
  const count =
    resolved === 'Semester' ? 2 : resolved === 'Trimester' ? 3 : resolved === 'Quarters' ? 4 : 0;
  const unit =
    resolved === 'Quarters' ? 'Quarter' : resolved === 'Trimester' ? 'Trimester' : 'Semester';
  const finalGrade = `${subject?.finalGrade ?? ''}`.trim();
  const oneFinalGrade = `${subject?.schedule_transcript ?? ''}` === 'One final Grade';
  const terms: { index: number; label: string }[] = [];

  if (resolved === 'Yearly') {
    const grade = retakeGradeText(subject);
    return [{ index: 0, label: grade ? `Yearly : ${grade}` : 'Yearly' }];
  }

  if (!oneFinalGrade && count) {
    for (let index = 0; index < count; index++) {
      const grade = `${subject?.grade?.[index] ?? ''}`.trim();
      const taken = Boolean(subject?.[RETAKE_TERM_FLAGS[index]]) || Boolean(grade);
      if (!taken) continue;
      terms.push({
        index,
        label: grade ? `${unit} ${index + 1} : ${grade}` : `${unit} ${index + 1}`,
      });
    }
  }

  if (terms.length > 0) return terms;

  const takenIndexes = RETAKE_TERM_FLAGS.map((flag, index) =>
    subject?.[flag] ? index : -1
  ).filter((index) => index >= 0);
  if (takenIndexes.length === 1) {
    const index = takenIndexes[0];
    const grade = `${subject?.grade?.[index] ?? ''}`.trim() || finalGrade;
    return [
      {
        index,
        label: grade ? `${unit} ${index + 1} : ${grade}` : `${unit} ${index + 1}`,
      },
    ];
  }
  if (finalGrade) {
    return [{ index: 0, label: `Final : ${finalGrade}` }];
  }
  return terms;
};

const SubjectConfig = (props: Props) => {
  const subjectRow = props.index + 1;
  const up = (suffix: string) =>
    props.dataUpPrefix ? `${props.dataUpPrefix}-${suffix}` : undefined;
  const [title, setTitle] = React.useState('');
  const [isExist, setIsExist] = React.useState<any>();
  const [apTestArray, setApTestArray] = React.useState<any>([]);
  const [ibTestArray, setIbTestArray] = React.useState<any>([]);
  const [generalTest, setGeneralTest] = React.useState<any>({});

  const collegeData = useAppSelector((store: any) => store.highSchool.collegeData);
  const buildName = (name: string) => {
    return `subjectDetails[${props.index}].${name}`;
  };

  const formItemValues = props.form.values.subjectDetails[props.index];
  const myGradeAndCourse = useAppSelector((store) => store.course.myGradeAndCourse);
  const location = useLocation();

  const retakeCourseOptions = React.useMemo(() => {
    const pageGrade = retakeGradeLabelFromPath(location.pathname);
    const currentName = `${formItemValues?.courseName ?? ''}`.trim().toLowerCase();
    const formSchool = `${props.form.values.schoolName ?? ''}`.trim();
    const formYear = `${props.form.values.schoolYear ?? ''}`.trim();
    const cardMatchesForm = (card: any) =>
      `${card?.schoolName ?? ''}`.trim() === formSchool &&
      `${card?.schoolYear ?? ''}`.trim() === formYear;
    const rows = new Map<
      string,
      { label: string; rank: number; terms: { index: number; label: string }[] }
    >();
    const put = (
      id: string,
      label: string,
      rank: number,
      terms: { index: number; label: string }[]
    ) => {
      if (!label) return;
      const existing = rows.get(id);
      const incomingHasGrade = label.includes(' : ');
      const existingHasGrade = existing?.label.includes(' : ');
      if (
        !existing ||
        rank > existing.rank ||
        (rank === existing.rank && !existingHasGrade && incomingHasGrade)
      ) {
        rows.set(id, { label, rank, terms });
      }
    };

    const savedCards: Record<string, any[]> = {};
    Object.entries(RETAKE_GRADE_LABELS).forEach(([field, gradeLabel]) => {
      const raw = myGradeAndCourse?.[field];
      const cards = Array.isArray(raw) ? raw : tryParseJSON(raw);
      savedCards[gradeLabel] = Array.isArray(cards) ? cards : [];
    });

    const pageCards = savedCards[pageGrade] || [];
    let matchedCardIndex = pageCards.findIndex((card) => {
      if (!cardMatchesForm(card)) return false;
      const savedName = `${card?.subjectDetails?.[props.index]?.courseName ?? ''}`
        .trim()
        .toLowerCase();
      return !!currentName && savedName === currentName;
    });
    if (matchedCardIndex < 0) {
      matchedCardIndex = pageCards.findIndex((card) => cardMatchesForm(card));
    }

    Object.entries(savedCards).forEach(([gradeLabel, cards]) => {
      cards.forEach((card: any, cardIndex: number) => {
        (card?.subjectDetails || []).forEach((subject: any, subjectIndex: number) => {
          if (
            gradeLabel === pageGrade &&
            cardIndex === matchedCardIndex &&
            subjectIndex === props.index
          ) {
            return;
          }
          const name = `${subject?.courseName ?? ''}`.trim();
          if (!name) return;
          put(
            `${gradeLabel}|${cardIndex}|${subjectIndex}`,
            formatRetakeOption(gradeLabel, subject),
            1,
            retakeTermsFor(`${card?.schedule ?? ''}`, subject)
          );
        });
      });
    });

    (props.form.values.subjectDetails || []).forEach((subject, index) => {
      if (index === props.index) return;
      const name = `${subject?.courseName ?? ''}`.trim();
      if (!name || !pageGrade) return;
      const cardIndex = matchedCardIndex < 0 ? 'live' : matchedCardIndex;
      put(
        `${pageGrade}|${cardIndex}|${index}`,
        formatRetakeOption(pageGrade, subject),
        2,
        retakeTermsFor(`${props.form.values.schedule ?? ''}`, subject)
      );
    });

    const gradeOrder = Object.values(RETAKE_GRADE_LABELS);
    return Array.from(rows.entries())
      .sort(([, a], [, b]) => {
        const gradeA = gradeOrder.findIndex((grade) => a.label.startsWith(grade));
        const gradeB = gradeOrder.findIndex((grade) => b.label.startsWith(grade));
        if (gradeA !== gradeB) return gradeA - gradeB;
        return a.label.localeCompare(b.label);
      })
      .map(([id, row]) => ({ id, value: row.label, name: row.label, terms: row.terms }));
  }, [
    formItemValues?.courseName,
    location.pathname,
    myGradeAndCourse,
    props.form.values.schoolName,
    props.form.values.schoolYear,
    props.form.values.subjectDetails,
    props.form.values.schedule,
    props.index,
  ]);

  const selectedRetakeOption =
    formItemValues?.isRetake === true
      ? retakeCourseOptions.find(
          (opt) =>
            opt.name === formItemValues?.retakeCourseName ||
            opt.id === formItemValues?.retakeCourseName
        )
      : undefined;
  const retakeTerms = selectedRetakeOption?.terms ?? [];
  const selectedRetakeSemesters = Array.isArray(formItemValues?.retakeSemesters)
    ? formItemValues.retakeSemesters.filter((index: number) =>
        retakeTerms.some((term) => term.index === index)
      )
    : retakeTerms.map((term) => term.index);

  // Keep dual-enrollment college visible even if label format drifted or list briefly empty.
  const collegeTookClassOptions = React.useMemo(() => {
    const opts = Array.isArray(collegeData) ? [...collegeData] : [];
    const current = formItemValues?.collegeTookClass;
    if (current && !opts.includes(current)) {
      opts.unshift(current);
    }
    return opts;
  }, [collegeData, formItemValues?.collegeTookClass]);

  // Rematch saved collegeTookClass to current Education college labels (ceeb / name).
  React.useEffect(() => {
    if (
      formItemValues?.typeOfClass !== 'Dual Enrollment' ||
      !formItemValues?.isTakeClassAtCollege ||
      !formItemValues?.collegeTookClass ||
      !collegeData?.length
    ) {
      return;
    }
    const matched = matchCollegeTookClassOption(formItemValues.collegeTookClass, collegeData);
    if (matched && matched !== formItemValues.collegeTookClass) {
      props.form.setFieldValue(`subjectDetails[${props.index}].collegeTookClass`, matched);
    }
  }, [collegeData, props.index, formItemValues?.typeOfClass, formItemValues?.isTakeClassAtCollege]);
  const highschoolRecords = useAppSelector((store: any) => store.highSchool.highschoolListObject);
  const highschoolData = React.useMemo(() => {
    const records = Array.isArray(highschoolRecords) ? highschoolRecords : [];
    const parseSchoolObject = (item: any) =>
      typeof item?.high_school_object === 'object'
        ? item.high_school_object
        : checkEnableParseJSON(item?.high_school_object, {});
    const schoolCode = `${props.form.values.schoolCode ?? ''}`.trim();
    const matched =
      records.find((item: any) => item.high_school_name === props.form.values.schoolName) ||
      records.find((item: any) => {
        if (!schoolCode) return false;
        const obj = parseSchoolObject(item);
        return (
          `${item.high_school_code ?? ''}`.trim() === schoolCode ||
          `${obj?.college_board_code ?? ''}`.trim() === schoolCode ||
          `${obj?.code ?? ''}`.trim() === schoolCode
        );
      });
    if (!matched) {
      return props.form.values.schoolName || schoolCode
        ? {
            school_name: props.form.values.schoolName,
            college_board_code: schoolCode || '',
          }
        : undefined;
    }
    const obj = parseSchoolObject(matched);
    return {
      ...obj,
      school_name: obj?.school_name || matched.high_school_name,
      high_school_name: matched.high_school_name,
      college_board_code:
        obj?.college_board_code || matched.high_school_code || schoolCode,
    };
  }, [highschoolRecords, props.form.values.schoolName, props.form.values.schoolCode]);

  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  let token = getAccessToken();
  const query = new URLSearchParams(location.search);
  const check:boolean = query.get('check')==='1';

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const getTestArray = async (studentId: string) => {
    const res = await dispatch(getACTSubjectTest(studentId));
    const dataLoaded: any = res.payload;

    if (dataLoaded) {
      const APTestArray = checkEnableParseJSON(dataLoaded.ap_test_array, []) ?? [];
      setApTestArray(APTestArray);
    }
  };

  const getIBArray = async (studentId: string) => {
    let res = await dispatch(getIBSubjectTest(studentId)).unwrap();
    const dataLoaded: any = res;
    if (dataLoaded) {
      const IBTestArray = checkEnableParseJSON(dataLoaded.ib_test_array, []) ?? [];
      setIbTestArray(IBTestArray);
    }
  };

  const getGeneralTest = async (studentId: string) => {
    let res = await dispatch(getGeneral(studentId)).unwrap();
    const dataLoaded: any = res;
    if (dataLoaded) {
      const generalTestArray =
        checkEnableParseJSON(dataLoaded.all_tests_wish_report_array, []) ?? [];
      setGeneralTest(generalTestArray);
    }
  };

  React.useEffect(() => {
    try {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        if (props.form && !collegeData.length) dispatch(getCollegeData(studentId));
        getTestArray(studentId);
        getIBArray(studentId);
        getGeneralTest(studentId);
      } else {
        handleLogout();
      }
    } catch (ex) {
      console.log('Error: ', ex);
    }
  }, []);

  const [semesterOption, setSemesterOption] = React.useState<any[]>([]);
  const initSchedule = () => {
    switch (props.form.values.schedule) {
      case 'Semester':
        setSemesterOption([
          { value: 'isFirstSemester', label: 'First Semester', fieldIndex: 0 },
          { value: 'isSecondSemester', label: 'Second Semester', fieldIndex: 1 },
        ]);
        props.form.setFieldValue(
          buildName('grade'),
          setArrayLength(props.form.values.subjectDetails[props.index]?.grade, 2, '')
        );
        props.form.setFieldValue(
          buildName('credits'),
          setArrayLength(props.form.values.subjectDetails[props.index]?.credits, 2, '')
        );
        break;
      case 'Trimester':
        setSemesterOption([
          { value: 'isFirstSemester', label: 'First Trimester', fieldIndex: 0 },
          { value: 'isSecondSemester', label: 'Second Trimester', fieldIndex: 1 },
          { value: 'isThirdSemester', label: 'Third Trimester', fieldIndex: 2 },
        ]);
        props.form.setFieldValue(
          buildName('grade'),
          setArrayLength(props.form.values.subjectDetails[props.index]?.grade, 3, '')
        );
        props.form.setFieldValue(
          buildName('credits'),
          setArrayLength(props.form.values.subjectDetails[props.index]?.credits, 3, '')
        );
        break;
      case 'Quarters':
        setSemesterOption([
          { value: 'isFirstSemester', label: 'First Quarter', fieldIndex: 0 },
          { value: 'isSecondSemester', label: 'Second Quarter', fieldIndex: 1 },
          { value: 'isThirdSemester', label: 'Third Quarter', fieldIndex: 2 },
          { value: 'isFourthSemester', label: 'Fourth Quarter', fieldIndex: 3 },
        ]);
        props.form.setFieldValue(
          buildName('grade'),
          setArrayLength(props.form.values.subjectDetails[props.index]?.grade, 4, '')
        );
        props.form.setFieldValue(
          buildName('credits'),
          setArrayLength(props.form.values.subjectDetails[props.index]?.credits, 4, '')
        );
        break;
      default:
        setSemesterOption([]);
        props.form.setFieldValue(buildName('grade'), []);
        props.form.setFieldValue(buildName('credits'), []);
    }
  };
  React.useEffect(() => {
    initSchedule();
  }, [props.form.values.schedule]);

  const [searchKey, setSearchKey] = React.useState('');

  const renderSC = (b: boolean) => {
    return b ? 'Summer Course' : '';
  };

  const buildStringFromArray = (arr: (string | number)[]) => {
    if (arr && arr.length > 0) {
      return arr
        .filter((item, index) => {
          if (index === 0 && !props.form.values?.subjectDetails[props.index]?.isFirstSemester)
            return false;
          if (index === 1 && !props.form.values?.subjectDetails[props.index]?.isSecondSemester)
            return false;
          if (index === 2 && !props.form.values?.subjectDetails[props.index]?.isThirdSemester)
            return false;
          if (index === 3 && !props.form.values?.subjectDetails[props.index]?.isFourthSemester)
            return false;
          return true;
        })
        .filter((i) => !!i)
        .join(', ');
    } else {
      return '';
    }
  };

  const genTitle = () => {
    let title = '';
    try {
      title += `${formItemValues.courseName ?? ''} - `;
      title += `${formItemValues.subject ?? ''} : `;
      title += `${buildStringFromArray(props.form.values.subjectDetails[props.index]?.grade)} `;

      if (formItemValues?.schedule_transcript !== 'One grade per term') {
        title += `${formItemValues.finalGrade ?? ''}`;
      }

      title += ` - Credits: ${buildStringFromArray(
        props.form.values.subjectDetails[props.index]?.credits
      )} `;

      if (formItemValues?.schedule_transcript !== 'One grade per term') {
        title += `${formItemValues.finalCredits ?? ''}`;
      }
    } catch (ex) {
      console.log('Error:', ex);
    }
    return title;
  };

  const checkCouserNameExist = async (courseName: String) => {
    const params = buildCourseSuggestParams(
      highschoolData,
      courseName,
      props.form.values.schoolYear
    );

    const res = await courseServices.getCourseSuggestSignal(
      { ...params, limit_item: 100 },
      new AbortController()
    );

    return res.filter((item: any) => item.course_title === courseName);
  };

  //1840 - auto select subject area and subject : D2 - Physical Science
  React.useEffect(() => {
    try {
      const itemSubject = checkCouserNameIncludes(
        `${props.form.values.subjectDetails[props.index]?.courseName ?? ''}`,
        'D2'
      );
      if (itemSubject.length > 0) {
        getSubjectsByType(props.form.values.subjectDetails[props.index]?.AGSubjectArea);
        props.form.setFieldValue(`subjectDetails[${props.index}].subject`, itemSubject[0]);
      }
    } catch (ex) {
      console.log('Error:', ex);
    }
  }, [props.form.values.subjectDetails[props.index]?.courseName]);

  React.useEffect(() => {
    setTitle(genTitle());

    checkCouserNameExist(props.form.values.subjectDetails[props.index]?.courseName).then((res) => {
      if (res.length > 0) {
        setIsExist(true);
        props.form.setFieldValue(`subjectDetails[${props.index}].isNew`, false);
      } else {
        setIsExist(false);
        props.form.setFieldValue(`subjectDetails[${props.index}].isNew`, true);
      }
    });
  }, []);

  React.useEffect(() => {
    setTitle(genTitle());
  }, [props.form.values.CMGradingScale, props.form.values.subjectDetails[props.index]]);

  React.useEffect(() => {
    if (props.form.values.subjectDetails[props.index]?.typeOfClass === 'Dual Enrollment') {
      props.form.setFieldValue(`subjectDetails[${props.index}].isTakeClassAtCollege`, true);
    }
  }, [props.form.values.subjectDetails[props.index]?.typeOfClass]);
  React.useEffect(() => {
    if (props.form.values.subjectDetails[props.index]?.schedule_transcript === 'One final Grade') {
      props.form.setFieldValue(`subjectDetails[${props.index}].credits`, ['', '', '', '']);
      props.form.setFieldValue(`subjectDetails[${props.index}].grade`, ['', '', '', '']);
    }
  }, [props.form.values.subjectDetails[props.index]?.schedule_transcript]);

  const textColor = () => {
    if (!props.form.values.subjectDetails[props.index]?.isNew && isExist) {
      return '#4d88f0';
    } else {
      if (
        props.form.values.subjectDetails[props.index]?.isNew === false &&
        props.form.values.subjectDetails[props.index]?.courseName
      ) {
        return '#4d88f0';
      } else {
        return 'black';
      }
    }
  };

  const reMapAPTestCourse = (subjectName: string) => {
    let subject: string = (subjectName ?? '').toLocaleLowerCase();
    if (subject === 'African American Studies'.toLocaleLowerCase()) {
      return 'African American Studies';
    }

    if (subject.includes('Art History'.toLocaleUpperCase())) {
      return 'Art History';
    }

    if (subjectName.includes('Studio Art')) {
      if (subjectName.includes('2D') || subject.includes('2-D')) {
        return 'Art: 2-D Art & Design';
      }
      if (subjectName.includes('3D') || subject.includes('3-D')) {
        return 'Art: 3-D Art & Design';
      }
      if (subjectName.includes('Drawing')) {
        return 'Art: Drawing';
      }
    }

    if (subjectName.includes('Biology')) {
      return 'Biology';
    }
    if (subjectName.includes('Calculus AB')) {
      return 'Calculus AB';
    }
    if (subjectName.includes('Calculus BC')) {
      return 'Calculus BC';
    }

    if (subjectName.includes('Chemistry')) {
      return 'Chemistry';
    }

    if (subject.includes('Chinese Language and Culture'.toLocaleLowerCase())) {
      return 'Chinese Language & Culture';
    }

    if (subject.includes('Government and Politics Comparative'.toLocaleLowerCase())) {
      return 'Government & Politics: Comparative';
    }

    if (subject.includes('Computer Science A'.toLocaleLowerCase())) {
      return 'Computer Science A';
    }

    if (subject.includes('Computer Science Principles'.toLocaleLowerCase())) {
      return 'Computer Science Principles';
    }

    if (subject.includes('Macroeconomics'.toLocaleLowerCase())) {
      return 'Economics: Macroeconomics';
    }

    if (subject.includes('Microeconomics'.toLocaleLowerCase())) {
      return 'Economics: Microeconomics';
    }

    if (subject.includes('English Language and Composition'.toLocaleLowerCase())) {
      return 'English Language & Composition';
    }
    if (subject.includes('English Language & Composition'.toLocaleLowerCase())) {
      return 'English Language & Composition';
    }
    if (subject.includes('English Language and Comp'.toLocaleLowerCase())) {
      return 'English Language & Composition';
    }

    if (subject.includes('English Literature and Composition'.toLocaleLowerCase())) {
      return 'English Literature & Composition';
    }
    if (subject.includes('English Literature & Composition'.toLocaleLowerCase())) {
      return 'English Literature & Composition';
    }
    if (subject.includes('English Literature and Comp'.toLocaleLowerCase())) {
      return 'English Literature & Composition';
    }

    if (subject.includes('Environmental Science'.toLocaleLowerCase())) {
      return 'Environmental Science';
    }

    if (subject.includes('European History'.toLocaleLowerCase())) {
      return 'European History';
    }

    if (subject.includes('French Language'.toLocaleLowerCase())) {
      return 'French Language & Culture';
    }
    if (subject.includes('French Language and Culture'.toLocaleLowerCase())) {
      return 'French Language & Culture';
    }

    if (subject.includes('German Language'.toLocaleLowerCase())) {
      return 'German Language & Culture';
    }
    if (subject.includes('German Language and Culture'.toLocaleLowerCase())) {
      return 'German Language & Culture';
    }

    if (subject.includes('Human Geography'.toLocaleLowerCase())) {
      return 'Human Geography';
    }

    if (subject.includes('Italian Language and Culture'.toLocaleLowerCase())) {
      return 'Italian Language & Culture';
    }
    if (subject.includes('Italian Language & Culture'.toLocaleLowerCase())) {
      return 'Italian Language & Culture';
    }

    if (subject.includes('Japanese Language and Culture'.toLocaleLowerCase())) {
      return 'Japanese Language & Culture';
    }
    if (subject.includes('Japanese Language & Culture'.toLocaleLowerCase())) {
      return 'Japanese Language & Culture';
    }

    if (subject.includes('Latin'.toLocaleLowerCase())) {
      return 'Latin';
    }

    if (subject.includes('Music Theory'.toLocaleLowerCase())) {
      return 'Music Theory';
    }

    if (subject.includes('Physics 1'.toLocaleLowerCase())) {
      return 'Physics 1';
    }

    if (subject.includes('Physics 2'.toLocaleLowerCase())) {
      return 'Physics 2';
    }

    if (subject.includes('Physics C: Electricity and Magnetism'.toLocaleLowerCase())) {
      return 'Physics C - Electricity & Magnetism';
    }

    if (subject.includes('Physics C: Mechanics'.toLocaleLowerCase())) {
      return 'Physics C Mechanics';
    }

    if (subject.includes('Precalculus'.toLocaleLowerCase())) {
      return 'Precalculus';
    }

    if (subject.includes('Psychology'.toLocaleLowerCase())) {
      return 'Psychology';
    }

    if (subject.includes('Research'.toLocaleLowerCase())) {
      return 'Research';
    }

    if (subject.includes('Seminar'.toLocaleLowerCase())) {
      return 'Seminar';
    }

    if (subject.includes('Spanish Language'.toLocaleLowerCase())) {
      return 'Spanish Language & Culture';
    }
    if (subject.includes('AP Spanish Language and Culture'.toLocaleLowerCase())) {
      return 'Spanish Language & Culture';
    }

    if (subject.includes('Spanish Literature'.toLocaleLowerCase())) {
      return 'Spanish Literature & Culture';
    }
    if (subject.includes('Spanish Literature and Culture'.toLocaleLowerCase())) {
      return 'Spanish Literature & Culture';
    }

    if (subject.includes('Statistics'.toLocaleLowerCase())) {
      return 'Statistics';
    }

    if (subject.includes('Government and Politics Comparative'.toLocaleLowerCase())) {
      return 'Government & Politics: Comparative';
    }
    if (subject.includes('Government & Politics Comparative'.toLocaleLowerCase())) {
      return 'Government & Politics: Comparative';
    }

    if (subject.includes('Government and Politics United States'.toLocaleLowerCase())) {
      return 'Government & Politics: United States';
    }
    if (subject.includes('Government & Politics United States'.toLocaleLowerCase())) {
      return 'Government & Politics: United States';
    }
    if (subject.includes('Government and Politics US'.toLocaleLowerCase())) {
      return 'Government & Politics: United States';
    }

    if (subject.includes('United States History'.toLocaleLowerCase())) {
      return 'United States History';
    }

    if (subject.includes('World History'.toLocaleLowerCase())) {
      return 'World History';
    }

    return subjectName;
  };

  const autoRefillAPTest = async (subject: string) => {
    try {
      console.log('run autoRefillAPTest');

      const newAPTest = {
        isReceivedScore: '',
        examStatus: 'Planned',
        subject: subject,
        subjectCM: subject,
        dateTaken: null,
        dateTakenCSUApp: '',
        dateTakenMonth: '',
        dateTakenYear: '',
        score: '',
        planToTakeExamMonth: '',
        planToTakeExamYear: '',
        planToTakeExam: '',
        isIncludeIntoCommonApp: false,
        isIncludeIntoUCApp: false,
        isIncludeIntoCSUApp: false,
      };
      const newAPTestArray = [...apTestArray, newAPTest];

      //#region Update is_AP_Subject flag of generalTest
      if (!generalTest?.is_AP_Subject) {
        const newGeneralTest = {
          ...generalTest,
          is_AP_Subject: true,
        };

        await dispatch(
          updateGeneral({
            student_id: studentId,
            all_tests_wish_report_array: JSON.stringify(newGeneralTest),
          })
        ).unwrap();
      }
      //#endregion
      await dispatch(
        updateACTSubjectTest({
          student_id: studentId,
          ap_test_array: JSON.stringify(newAPTestArray),
        })
      ).unwrap();
      setApTestArray(newAPTestArray);
    } catch (ex) {}
  };

  // const autoReFillIBTest = async(subject: string) => {
  //   try {
  //     const newIBTest = {
  //       isReceivedScore: '',
  //       examStatus: 'Planned',
  //       subject: subject,
  //       dateTaken: null,
  //       score: '',
  //       ibExam: '',
  //       ibExamName: '', // for UC App only
  //       level: '',
  //       ibExamSubjectName: '', // for UC App only
  //       ibExamSubjectNameDescribeOther: '', // for UC App only
  //       ibExamSubjectNameCSUApp: '', // for CSU App only
  //       ibExamSpecifyLanguageCSUApp: '', // for CSU App only
  //       language: '',
  //       isIncludeIntoCommonApp: false,
  //       isIncludeIntoUCApp: false,
  //       isIncludeIntoCSUApp: false,
  //     };
  //     const newIBTestArray = [...ibTestArray, newIBTest];

  //     if (!generalTest?.is_IB_Subject) {
  //       const newGeneralTest = {
  //         ...generalTest,
  //         is_IB_Subject: true,
  //       };

  //       await dispatch(
  //         updateGeneral({
  //           student_id: studentId,
  //           all_tests_wish_report_array: JSON.stringify(newGeneralTest),
  //         })
  //       ).unwrap();
  //     }

  //     await dispatch(
  //       updateIBSubjectTest({
  //         student_id: studentId,
  //         ib_test_array: JSON.stringify(newIBTestArray),
  //       })
  //     ).unwrap();
  //   }
  //   catch(ex){
  //     console.log('Error:', ex);
  //   }
  // }

  const handleSelectCourse = async (courseName: string) => {
    //console.log("🚀 ~ handleSelectCourse ~ courseName:", courseName)
    if (courseName) {
      if (`${courseName}`.substring(0, 3) === 'AP ') {
        let subject = reMapAPTestCourse(courseName.substring(3));

        let isExist = false;
        for (let i = 0; i < apTestArray.length; i++) {
          let item: any = apTestArray[i];
          if (item?.subjectCM === subject && item?.planToTakeExam !== '') {
            isExist = true;
            console.log('item:', item);
            break;
          }
        }
        console.log('apTestArray:', apTestArray);
        console.log('isExist:', isExist);
        console.log('subjectCM:', subject);
        if (!isExist) {
          await autoRefillAPTest(subject);
        }

        //await autoRefillAPTest(subject);
        props.form.setFieldValue(`subjectDetails[${props.index}].isNew`, false);
      }

      // if (`${courseName}`.split(' ').includes('IB')) {
      //   await autoReFillIBTest(courseName);
      //   props.form.setFieldValue(`subjectDetails[${props.index}].isNew`, false);
      // }
    }
  };

  const languageNameOptions = [
    'American Sign Language',
    'Arabic',
    'Armenian',
    'Chinese',
    'Farsi',
    'Filipino',
    'French',
    'German',
    'Greek',
    'Hebrew',
    'Hindi',
    'Hmong',
    'Italian',
    'Japanese',
    'Khmer',
    'Korean',
    'Latin',
    'Other Language',
    'Portuguese',
    'Punjabi',
    'Russian',
    'Spanish',
    'Tamil',
    'Turkish',
    'Vietnamese',
  ];
  const isWeightedCourseOptions = ['', 'Yes', 'No'];
  const scheduleTranscriptOptions = [
    'One final Grade',
    'One grade per term',
    'One grade per term and one final grade',
  ];

  // const AutoFill_APSubjectTests = async (subjectCM:string) => {
  //   studentId = Cookies.get('userId');
  //   token = Cookies.get(authenticateSettings.tokenName);
  //   if (token && studentId) {
  //     try {
  //       let res = await dispatch(getACTSubjectTest(studentId));
  //       const dataLoaded: any = res.payload;
  //       let values: any = {
  //         ...dataLoaded,
  //         ap_test_array: checkEnableParseJSON(dataLoaded.ap_test_array, []) ?? [],
  //         csu_info: {...checkEnableParseJSON(dataLoaded.csu_info)},
  //         is_have_ap_exam_report: BoolToString(dataLoaded.is_have_ap_exam_report),
  //       };

  //       fixApSubjectTestValues(values);
  //       if (values &&  values.ap_test_array && values.ap_test_array.length>0) {
  //         let isExist = false;
  //         for(let i=0; i< values.ap_test_array.length; i++) {
  //           let item:any = values.ap_test_array[i];
  //           if (item?.subjectCM === subjectCM) {
  //             isExist = true;
  //             break;
  //           }
  //         }
  //         if (!isExist) {
  //           values.ap_test_array.push({
  //               "isReceivedScore": "",
  //               "examStatus": "Planned",
  //               "subject": subjectCM,
  //               "subjectCM": subjectCM,
  //               "dateTaken": "",
  //               "dateTakenCSUApp": "",
  //               "dateTakenMonth": "",
  //               "dateTakenYear": "",
  //               "score": "",
  //               "planToTakeExamMonth": "",
  //               "planToTakeExamYear": "",
  //               "planToTakeExam": "",
  //               "isIncludeIntoCommonApp": true,
  //               "isIncludeIntoUCApp": true,
  //               "isIncludeIntoCSUApp": true,
  //           });

  //           const newValues = {
  //             ...values,
  //             student_id: studentId,
  //             is_have_ap_exam_report: formatBoolean(values.is_have_ap_exam_report),
  //             ap_test_array: JSON.stringify(values.ap_test_array),
  //           };
  //           await dispatch(updateACTSubjectTest(newValues));
  //         }
  //       }

  //      } catch (ex) {
  //       console.log('Error:', ex);
  //     }
  //   }
  // }

  return (
    <CardConfig
      id={`subjectItem${props.index + 1}`}
      expandAll={props.expandAll}
      headerElement={
        <>
          <span
            className="p-1"
            style={{
              color: textColor(),
            }}
          >
            {title}
          </span>
          <span className="floatRight" style={{ fontStyle: 'italic' }}>
            {props.form.values.subjectDetails[props.index]?.isSummerCourse &&
              `(${renderSC(props.form.values.subjectDetails[props.index]?.isSummerCourse)})`}
          </span>
          <span className="floatRight">
            <strong className="text-field-light">
              {props.index + 1}/{props.total}
            </strong>
          </span>
        </>
      }
      indexText={''}
    >
      <div className="px-3 gm-form-fields">
        <Grid container spacing={2}>
          <Grid xs={12}>
            <CheckboxInput
              logo="span-csu-logo"
              label="Summer Course - Taken After This Grade Year"
              name="isSummerCourse"
              dataUp={up(`summer-course-${props.courseIndex}-${subjectRow}`)}
              values={props.form.values.subjectDetails[props.index]?.isSummerCourse}
              onChange={(e) => {
                props.form.setFieldValue(
                  `subjectDetails[${props.index}].isSummerCourse`,
                  e.target.checked
                );
              }}
              disabled={props.disabled}
            />
          </Grid>

          <Grid xs={12}>
            <TextInput
              id={`courseName_${props.courseIndex}_${props.index + 1}`}
              className="common-flag"
              mdCol="12"
              label="Course Name*"
              dataUp={up(`course-title-${props.courseIndex}-${subjectRow}`)}
              countText={100}
              name={`subjectDetails[${props.index}].courseName`}
              values={props.form.values.subjectDetails[props.index]?.courseName}
              onChange={(e) => {
                setSearchKey(e.target.value);
                let newValues: any = Object.assign({}, props.form.values);
                newValues.subjectDetails[props.index].courseName = e.target.value;
                newValues.subjectDetails[props.index].isNew = true;
                newValues.subjectDetails[props.index].typeOfClass = '';
                newValues.subjectDetails[props.index].isWeightedCourse = '';
                newValues.subjectDetails[props.index].AGSubjectArea = '';
                newValues.subjectDetails[props.index].subject = '';
                props.form.setValues(newValues);
              }}
              isMissing={
                !props.form.values.subjectDetails[props.index]?.courseName && check ? true : false
              }
              disabled={props.disabled}
            />
          </Grid>

          {/* New code here for course base on highschool ===*/}
          {searchKey?.length > 0 ? (
            <Grid xs={12}>
              <SuggestCourse
                searchKey={searchKey}
                schoolYear={props.form.values.schoolYear}
                currentHighschool={highschoolData}
                onUpdateCourseTitle={(course) => {
                  console.log('props.form.values:', props.form.values);
                  handleSelectCourse(course.course_title);
                  let newValues: any = Object.assign({}, props.form.values);
                  newValues.subjectDetails[props.index].courseName = course.course_title;
                  newValues.subjectDetails[props.index].AGSubjectArea = course.subject_area;
                  newValues.subjectDetails[props.index].subject = course.discipline;
                  newValues.schoolYear = course.course_list_year;
                  newValues.subjectDetails[props.index].otherClass = '';
                  newValues.subjectDetails[props.index].isNew = false;

                  // Prefill typeOfClass và isWeightedCourse chỉ khi chọn course
                  if (`${course.course_title}`.substring(0, 3) === 'AP ') {
                    newValues.subjectDetails[props.index].typeOfClass = 'Advanced Placement (AP)';
                    newValues.subjectDetails[props.index].isWeightedCourse = 'Yes';
                  } else if (`${course.course_title}`.split(' ').includes('IB')) {
                    newValues.subjectDetails[props.index].typeOfClass =
                      'International Baccalaureate (IB)';
                    newValues.subjectDetails[props.index].isWeightedCourse = 'Yes';
                  } else if (course.is_uc_honors) {
                    newValues.subjectDetails[props.index].typeOfClass = '';
                    newValues.subjectDetails[props.index].isWeightedCourse = 'Yes';
                  } else {
                    newValues.subjectDetails[props.index].typeOfClass = '';
                    newValues.subjectDetails[props.index].isWeightedCourse = '';
                  }

                  fixCourseValues(newValues.subjectDetails[props.index]);
                  props.form.setValues(newValues);

                  //#region Auto fill AP Subject Tests :
                  // if (course.course_title.includes('AP Spanish Language')) {
                  //   AutoFill_APSubjectTests('Spanish Language');
                  // } else
                  // if (course.course_title.includes('AP Spanish Literature')) {
                  //     AutoFill_APSubjectTests('Spanish Literature');
                  // }
                  //#endregion
                }}
                disabled={props.disabled}
              />
            </Grid>
          ) : null}

          {/* === New code here for course base on highschool */}
          <Grid xs={12} md={6}>
            <SelectInput
              mdCol="12"
              form={props.form}
              option={subjectAreaOptions}
              label="A-G Subject Area"
              dataUp={up(`ag-subject-${props.courseIndex}-${subjectRow}`)}
              values={props.form.values.subjectDetails[props.index]?.AGSubjectArea}
              name={`subjectDetails[${props.index}].AGSubjectArea`}
              onChange={(e) => {
                props.form.setFieldValue(`subjectDetails[${props.index}].subject`, '');
                props.form.handleChange(e);
              }}
              feedback={
                (props.form.values.subjectDetails[props.index]?.AGSubjectArea?.length
                  ? ''
                  : `Course Does Not Satisfy an A-G Requirement. `) +
                'If Science, please select D1 - Biological Science or D2 - Physical Science.'
              }
              disabled={props.disabled}
            />
          </Grid>

          <Grid xs={12} md={6}>
            <SelectInput
              mdCol="12"
              className="common-flag"
              form={props.form}
              option={getSubjectsByType(
                props.form.values.subjectDetails[props.index]?.AGSubjectArea
              )}
              label="Subject/Discipline"
              dataUp={up(`subject-${props.courseIndex}-${subjectRow}`)}
              values={props.form.values.subjectDetails[props.index]?.subject}
              name={`subjectDetails[${props.index}].subject`}
              onChange={(e) => {
                props.form.handleChange(e);
              }}
              feedback={`Please choose the closest matching name or "Other' if your class is not on the list.`}
              disabled={props.disabled}
            />
          </Grid>

          {(`${props.form.values.subjectDetails[props.index]?.AGSubjectArea}`
            .toLowerCase()
            .includes('other than english') ||
            `${props.form.values.subjectDetails[props.index]?.subject}`
              .toLowerCase()
              .includes('other than english')) && (
            <Grid xs={12} md={6}>
              <SelectInput
                mdCol="12"
                form={props.form}
                option={languageNameOptions}
                label="Language Name"
                dataUp={up(`language-name-${props.courseIndex}-${subjectRow}`)}
                values={props.form.values.subjectDetails[props.index]?.languageName}
                name={`subjectDetails[${props.index}].languageName`}
                onChange={props.form.handleChange}
                disabled={props.disabled}
              />
            </Grid>
          )}

          <Grid xs={12} md={6}>
            <SelectInput
              id={`typeOfClass_${props.courseIndex}_${props.index + 1}`}
              name={`subjectDetails[${props.index}].typeOfClass`}
              label="Type of Class *"
              dataUp={up(`level-${props.courseIndex}-${subjectRow}`)}
              option={classTypeOption}
              values={props.form.values.subjectDetails[props.index]?.typeOfClass}
              onChange={(e) => {
                props.form.handleChange(e);
              }}
              isMissing={
                !props.form.values.subjectDetails[props.index]?.typeOfClass && check ? true : false
              }
              disabled={props.disabled}
            />
          </Grid>

          <Grid xs={12} md={6}>
            <SelectInput
              label="Is this a weighted course?"
              option={isWeightedCourseOptions}
              dataUp={up(`weighted-${props.courseIndex}-${subjectRow}`)}
              name={`subjectDetails[${props.index}].isWeightedCourse`}
              values={props.form.values.subjectDetails[props.index]?.isWeightedCourse}
              onChange={props.form.handleChange}
              disabled={props.disabled}
            />
          </Grid>

          {
            // props.form.values.subjectDetails[props.index]?.subject === 'Art (Visual or Performing)' ||
            // props.form.values.subjectDetails[props.index]?.subject === 'Computer Science ' ||
            // props.form.values.subjectDetails[props.index]?.subject === 'Religion' ||
            props.form.values.subjectDetails[props.index]?.subject === 'Other' && (
              <Grid xs={12} md={6}>
                <TextInput
                  label="Class Name on Transcript *"
                  countText={50}
                  name={`subjectDetails[${props.index}].otherClass`}
                  values={props.form.values.subjectDetails[props.index]?.otherClass}
                  onChange={props.form.handleChange}
                  disabled={props.disabled}
                />
              </Grid>
            )
          }
        </Grid>

        <Grid container spacing={2}>
          {props.form.values.subjectDetails[props.index].typeOfClass === 'Dual Enrollment' && (
            <>
              <Grid xs={12}>
                <CheckboxInput
                  label="I took this class at a college and/or I received college credit for this class."
                  name={`subjectDetails[${props.index}].isTakeClassAtCollege`}
                  values={props.form.values.subjectDetails[props.index]?.isTakeClassAtCollege}
                  onChange={props.form.handleChange}
                  disabled={props.disabled}
                />
              </Grid>
              {props.form.values.subjectDetails[props.index].isTakeClassAtCollege && (
                <>
                  <Grid xs={12}>
                    <SelectInput
                      id={`collegeTookClass_${props.courseIndex}_${props.index + 1}`}
                      label="Select College *"
                      option={collegeTookClassOptions}
                      mdCol="12"
                      name={`subjectDetails[${props.index}].collegeTookClass`}
                      values={props.form.values.subjectDetails[props.index]?.collegeTookClass}
                      onChange={props.form.handleChange}
                      isMissing={
                        !props.form.values.subjectDetails[props.index]?.collegeTookClass && check
                          ? true
                          : false
                      }
                      disabled={props.disabled}
                    />
                  </Grid>

                  <Grid xs={12} md={6}>
                    <GroupRadioButton
                      verticalLayout={true}
                      id={`CNGradingScale_${props.courseIndex}_${props.index + 1}`}
                      mdCol={12}
                      label="Grading Scale *"
                      name={`subjectDetails[${props.index}].CNGradingScale`}
                      onChange={props.form.handleChange}
                      options={gradingScale2Options}
                      values={props.form.values.subjectDetails[props.index]?.CNGradingScale}
                      isMissing={
                        !props.form.values.subjectDetails[props.index]?.CNGradingScale && check
                          ? true
                          : false
                      }
                      disabled={props.disabled}
                    />
                  </Grid>
                </>
              )}
              <Grid xs={12}>
                <div className="text-field-light">
                  Please add the details of this course under your College Courses. Colleges may not
                  allow for the course to be listed under the high school coursework on their
                  admission application.
                  <span className="span-uc-csu-logo"></span>
                </div>
              </Grid>

              {props.form.values.subjectDetails[props.index]?.CNGradingScale === 'Numbers' && (
                <>
                  <Grid xs={12} md={6}>
                    <TextInput
                      id={`lowestGrade_${props.courseIndex}_${props.index + 1}`}
                      className="custom_input"
                      label="What is the lowest possible number grade at this school?*"
                      type="number"
                      name={`subjectDetails[${props.index}].lowestGrade`}
                      values={props.form.values.subjectDetails[props.index]?.lowestGrade}
                      onChange={props.form.handleChange}
                      isMissing={
                        !props.form.values.subjectDetails[props.index]?.lowestGrade && check
                          ? true
                          : false
                      }
                      disabled={props.disabled}
                    />
                  </Grid>

                  <Grid xs={12} md={6}>
                    <TextInput
                      id={`highestGrade_${props.courseIndex}_${props.index + 1}`}
                      className="custom_input"
                      label="What is the highest possible number grade at this school?*"
                      type="number"
                      name={`subjectDetails[${props.index}].highestGrade`}
                      values={props.form.values.subjectDetails[props.index]?.highestGrade}
                      onChange={props.form.handleChange}
                      isMissing={
                        !props.form.values.subjectDetails[props.index]?.highestGrade && check
                          ? true
                          : false
                      }
                      disabled={props.disabled}
                    />
                  </Grid>
                </>
              )}

              {props.form.values.subjectDetails[props.index]?.CNGradingScale === 'Other' && (
                <Grid xs={12} md={6}>
                  <TextInput
                    id={`otherGradeScale_${props.courseIndex}_${props.index + 1}`}
                    label="Other Grading Scale *"
                    countText={60}
                    name={`subjectDetails[${props.index}].otherGradeScale`}
                    values={props.form.values.subjectDetails[props.index]?.otherGradeScale}
                    onChange={props.form.handleChange}
                    isMissing={
                      !props.form.values.subjectDetails[props.index]?.otherGradeScale && check
                        ? true
                        : false
                    }
                    disabled={props.disabled}
                  />
                </Grid>
              )}
            </>
          )}
        </Grid>

        <div className="border w-100 my-3" />

        {(props.form.values.schedule === 'Semester' ||
          props.form.values.schedule === 'Trimester' ||
          props.form.values.schedule === 'Quarters') && (
          <div>
            <div
              id={`takeSemester_${props.courseIndex}_${props.index + 1}`}
              className="label-0.875rem  mb-3"
              style={{
                backgroundColor:
                  !(
                    props.form.values.subjectDetails[props.index]?.isFirstSemester ||
                    props.form.values.subjectDetails[props.index]?.isSecondSemester ||
                    props.form.values.subjectDetails[props.index]?.isThirdSemester ||
                    props.form.values.subjectDetails[props.index]?.isFourthSemester
                  ) && check
                    ? '#FFEBEB'
                    : '',
                display: 'inline-block',
              }}
            >
            During which {props.form.values.schedule?.toLowerCase() ?? 'term'}(s) did you take this class? *
            </div>

            <Grid container spacing={2}>
              {semesterOption.map((opt, index) => {
                let key = opt.value as keyof SubjectDetail;
                const handleUncheck = () => {
                  let credits = props.form.values.subjectDetails[props.index]?.credits;
                  credits[index] = '';
                  props.form.setFieldValue(`subjectDetails[${props.index}].credits`, credits);
                  let grade = props.form.values.subjectDetails[props.index]?.grade;
                  grade[index] = '';
                  props.form.setFieldValue(`subjectDetails[${props.index}].grade`, grade);
                };
                return (
                  <Grid xs={12} md={12} key={index}>
                    <CheckboxInput
                      name={`subjectDetails[${props.index}].[${key}]`}
                      label={opt.label}
                      dataUp={up(`term-${props.courseIndex}-${subjectRow}-${index + 1}`)}
                      onChange={(e: any) => {
                        props.form.handleChange(e);
                        e.target.value === false && handleUncheck();
                      }}
                      values={props.form.values.subjectDetails[props.index]?.[key]}
                      // isMissing={
                      //   index === 0
                      //     ? !props.form.values.subjectDetails[props.index]?.[key] &&
                      //       (props.form.values.subjectDetails[props.index]?.schedule_transcript ===
                      //         props.form.values.subjectDetails[props.index]?.schedule_transcript ===
                      //         'One grade per term' ||
                      //           'One grade per term and one final grade') &&
                      //       check
                      //       ? true
                      //       : false
                      //     : !props.form.values.subjectDetails[props.index]?.isFirstSemester &&
                      //       !props.form.values.subjectDetails[props.index]?.[key] &&
                      //       (props.form.values.subjectDetails[props.index]?.schedule_transcript ===
                      //         'One grade per term' ||
                      //         props.form.values.subjectDetails[props.index]?.schedule_transcript ===
                      //           'One grade per term and one final grade') &&
                      //       check
                      //     ? true
                      //     : false
                      // }
                      disabled={props.disabled}
                    />
                  </Grid>
                );
              })}
            </Grid>

            <Grid xs={12}>
              <GroupRadioButton
                verticalLayout={true}
                id={`scheduleTranscript_${props.courseIndex}_${props.index + 1}`}
                className="py-3"
                mdCol={12}
                options={scheduleTranscriptOptions}
                label="How are the grades for this class reported on your transcript? *"
                dataUp={up(`term-${props.courseIndex}-${subjectRow}`)}
                name={`subjectDetails[${props.index}].schedule_transcript`}
                values={props.form.values.subjectDetails[props.index]?.schedule_transcript}
                onChange={props.form.handleChange}
                onClear={(e: any) => {
                  props.form.setFieldValue(
                    `subjectDetails[${props.index}].schedule_transcript`,
                    ''
                  );
                  initSchedule();
                }}
                isMissing={
                  !props.form.values.subjectDetails[props.index]?.schedule_transcript && check
                    ? true
                    : false
                }
                disabled={props.disabled}
              />
            </Grid>
          </div>
        )}

        <Grid container spacing={2}>
          {(semesterOption || []).map((opt, index) => {
            let key = opt.value as keyof SubjectDetail;
            let formik = props.form.values.subjectDetails[props.index];
            if (index === 0 && !formik?.isFirstSemester) return <div key={index} />;
            if (index === 1 && !formik?.isSecondSemester) return <div key={index} />;
            if (index === 2 && !formik?.isThirdSemester) return <div key={index} />;
            if (index === 3 && !formik?.isFourthSemester) return <div key={index} />;
            return (
              <React.Fragment key={index}>
                <Grid xs={12} md={6}>
                  {props.form.values.CMGradingScale === 'Other' ? (
                    <TextInput
                      id={`grade_${props.courseIndex}_${props.index + 1}_${index}`}
                      hidden={
                        !formik?.[key] ||
                        formik?.schedule_transcript === 'One final Grade' ||
                        !formik?.schedule_transcript
                      }
                      label={`${props.form.values.schedule} ${index + 1} Grade *`}
                      dataUp={up(`grade-${props.courseIndex}-${subjectRow}-${index + 1}`)}
                      countText={5}
                      values={formik?.grade[index]}
                      name={`subjectDetails[${props.index}].grade[${index}]`}
                      onChange={props.form.handleChange}
                      isMissing={!formik?.grade[index] && check ? true : false}
                      disabled={props.disabled}
                    />
                  ) : (
                    <SelectInput
                      id={`grade_${props.courseIndex}_${props.index + 1}_${index}`}
                      hidden={
                        !formik?.[key] ||
                        formik?.schedule_transcript === 'One final Grade' ||
                        !formik?.schedule_transcript
                      }
                      form={props.form}
                      option={props.gradingOptions}
                      label={`${props.form.values.schedule} ${index + 1} Grade *`}
                      dataUp={up(`grade-${props.courseIndex}-${subjectRow}-${index + 1}`)}
                      defautlValues={''}
                      values={formik?.grade[index]}
                      name={`subjectDetails[${props.index}].grade[${index}]`}
                      onChange={props.form.handleChange}
                      isMissing={!formik?.grade[index] && check ? true : false}
                      disabled={props.disabled}
                    />
                  )}
                </Grid>
                <Grid xs={12} md={6}>
                  <TextInput
                    id={`credits_${props.courseIndex}_${props.index + 1}_${index}`}
                    hidden={
                      !formik?.[key] ||
                      formik?.schedule_transcript === 'One final Grade' ||
                      !formik?.schedule_transcript
                    }
                    label={`${props.form.values.schedule} ${index + 1} Credits *`}
                    dataUp={up(`credits-${props.courseIndex}-${subjectRow}-${index + 1}`)}
                    type="number"
                    decimalStep={0.001}
                    name={`subjectDetails[${props.index}].credits[${index}]`}
                    values={formik?.credits[index]}
                    onChange={(e) =>
                      props.form.setFieldValue(
                        `subjectDetails[${props.index}].credits[${index}]`,
                        Math.round(e.target.value * 1000) / 1000
                      )
                    }
                    isMissing={!formik?.credits[index] && check ? true : false}
                    disabled={props.disabled}
                  />
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>

        <Grid container spacing={2}>
          <Grid xs={12} md={6}>
            {props.form.values.CMGradingScale === 'Other' ? (
              <TextInput
                id={`finalGrade_${props.courseIndex}_${props.index + 1}`}
                hidden={
                  props.form.values.subjectDetails[props.index]?.schedule_transcript ===
                  'One grade per term'
                }
                label="Final Grade *"
                dataUp={up(`grade-${props.courseIndex}-${subjectRow}`)}
                countText={5}
                values={props.form.values.subjectDetails[props.index]?.finalGrade}
                name={`subjectDetails[${props.index}].finalGrade`}
                onChange={props.form.handleChange}
                isMissing={
                  !props.form.values.subjectDetails[props.index]?.finalGrade && check ? true : false
                }
                disabled={props.disabled}
              />
            ) : (
              <SelectInput
                id={`finalGrade_${props.courseIndex}_${props.index + 1}`}
                hidden={
                  props.form.values.subjectDetails[props.index]?.schedule_transcript ===
                  'One grade per term'
                }
                form={props.form}
                option={props.gradingOptions}
                label="Final Grade *"
                dataUp={up(`grade-${props.courseIndex}-${subjectRow}`)}
                defautlValues={''}
                values={props.form.values.subjectDetails[props.index]?.finalGrade}
                name={`subjectDetails[${props.index}].finalGrade`}
                onChange={props.form.handleChange}
                isMissing={
                  !props.form.values.subjectDetails[props.index]?.finalGrade && check ? true : false
                }
                disabled={props.disabled}
              />
            )}
          </Grid>

          <Grid xs={12} md={6}>
            <TextInput
              id={`finalCredits_${props.courseIndex}_${props.index + 1}`}
              hidden={
                props.form.values.subjectDetails[props.index]?.schedule_transcript ===
                'One grade per term'
              }
              label="Final Credits *"
              dataUp={up(`credits-${props.courseIndex}-${subjectRow}`)}
              decimalStep={0.001}
              type="number"
              name={`subjectDetails[${props.index}].finalCredits`}
              values={props.form.values.subjectDetails[props.index]?.finalCredits}
              onChange={(e) =>
                props.form.setFieldValue(
                  `subjectDetails[${props.index}].finalCredits`,
                  Math.round(e.target.value * 1000) / 1000
                )
              }
              isMissing={
                !(props.form.values.subjectDetails[props.index]?.finalCredits !== '') && check
                  ? true
                  : false
              }
              disabled={props.disabled}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid xs={12}>
            <CheckboxInput
              id={`isRetake_${props.courseIndex}_${props.index + 1}`}
              label="Check the box if this is a course you retook."
              name={buildName('isRetake')}
              values={formItemValues?.isRetake === true}
              disabled={props.disabled}
              onChange={(e) => {
                const checked = Boolean(e?.target?.checked);
                props.form.setFieldValue(buildName('isRetake'), checked);
                if (!checked) {
                  props.form.setFieldValue(buildName('retakeCourseName'), '');
                  props.form.setFieldValue(buildName('retakeSemesters'), []);
                }
              }}
            />
          </Grid>
          {formItemValues?.isRetake === true && (
          <Grid xs={12}>
            <SelectInput
              key={`retakeCourse_${props.courseIndex}_${props.index + 1}_${retakeSelectionLabel(
                selectedRetakeOption,
                selectedRetakeSemesters
              )}`}
              id={`retakeCourse_${props.courseIndex}_${props.index + 1}`}
              label="If so, which course did you retake?"
              placeholder={retakeCourseOptions.length ? '' : 'No other courses entered'}
              option={retakeCourseOptions.length ? retakeCourseOptions : ['No other courses entered']}
              freezeOptionsOnOpen
              name={buildName('retakeCourseName')}
              values={
                formItemValues?.isRetake
                  ? retakeCourseOptions.find(
                      (opt) =>
                        opt.name === formItemValues?.retakeCourseName ||
                        opt.id === formItemValues?.retakeCourseName
                    )?.id || ''
                  : ''
              }
              disabled={props.disabled}
              renderValue={() =>
                selectedRetakeOption
                  ? retakeSelectionLabel(selectedRetakeOption, selectedRetakeSemesters)
                  : ''
              }
              onChange={(e) => {
                const raw = `${e?.target?.value ?? ''}`;
                if (!raw || raw === 'No other courses entered') return;
                const match = retakeCourseOptions.find((opt) => opt.id === raw || opt.name === raw);
                props.form.setFieldValue(buildName('retakeCourseName'), match?.name || raw);
                // Leave terms unchecked. Auto-checking every term replaces the whole
                // original course, including a semester the student did not retake.
                props.form.setFieldValue(buildName('retakeSemesters'), []);
              }}
              isMissing={
                formItemValues?.isRetake === true && !formItemValues?.retakeCourseName && check
                  ? true
                  : false
              }
            />
          </Grid>
          )}
          {formItemValues?.isRetake === true && retakeTerms.length > 0 && (
            <Grid xs={12}>
              <div className="label-0.875rem mb-2">Select the term and grade you're replacing.</div>
              {retakeTerms.map((term, termIndex) => (
                <CheckboxInput
                  key={term.index}
                  id={`retakeSemester_${props.courseIndex}_${props.index + 1}_${term.index}`}
                  label={term.label}
                  name={buildName('retakeSemesters')}
                  values={selectedRetakeSemesters.includes(term.index)}
                  disabled={props.disabled}
                  isMissing={selectedRetakeSemesters.length === 0 && (check) && termIndex === 0}
                  onChange={(e) => {
                    const checked = Boolean(e?.target?.checked);
                    const next = checked
                      ? Array.from(new Set([...selectedRetakeSemesters, term.index])).sort(
                          (a, b) => a - b
                        )
                      : selectedRetakeSemesters.filter((index) => index !== term.index);
                    props.form.setFieldValue(buildName('retakeSemesters'), next);
                  }}
                />
              ))}
            </Grid>
          )}
        </Grid>

        <div className="border w-100 my-3" />
        {/* <CheckboxInput
          label={`${props.form.values.schoolName} used block scheduling for this class.`}
          name={`subjectDetails[${props.index}].isUsedBlockScheduling`}
          values={props.form.values.subjectDetails[props.index]?.isUsedBlockScheduling}
          onChange={props.form.handleChange}
        /> */}
      </div>
      <style scoped>{`
        .gm-form-fields {
          max-width: 100%;
        }
        div.custom_input label.form-label {
          letter-spacing: 0;
        }
      `}</style>
    </CardConfig>
  );
};

export const chkSameGrade = (schoolItem: any, level: string) => {
  if (schoolItem === null) return false;
  if (schoolItem && schoolItem.grade && schoolItem.grade.length > 0) {
    for (let i = 0; i < schoolItem.grade.length; i++) {
      let grade = schoolItem.grade[i];
      if (grade === level) {
        return { grade: grade as any, index: i as number };
      }
    }
  }
  return false;
};

export const countSameGrade = (schoolItem: any, level: string) => {
  let arr: any[] = [];
  if (schoolItem && schoolItem.grade && schoolItem.grade.length > 0) {
    for (let i = 0; i < schoolItem.grade.length; i++) {
      let grade = schoolItem.grade[i];
      if (grade === level) {
        arr.push({ grade: grade as any, index: i as number });
      }
    }
    return arr;
  }
  return null;
};

export const getSchoolGradeItems = (highschoolData: any[], level: string) => {
  let arr: any[] = [];
  if (highschoolData && highschoolData.length > 0) {
    for (let i = 0; i < highschoolData.length; i++) {
      let item: any = highschoolData[i];
      if (chkSameGrade(item, level)) {
        arr.push({ item: item as any, index: i as number });
      }
    }
    return arr;
  }
  return null;
};

export default SubjectConfig;
